module.exports = __webpack_public_path__ + "static/media/13n.01dbc98d.png";